import { useState } from 'react';
import DDQList from '../../components/admin/ddq/DDQList';
import DDQForm from '../../components/admin/ddq/DDQForm';
import Button from '../../components/shared/UI/Button';

export default function DDQPage() {
  const [view, setView] = useState('list');
  const [selectedTemplate, setSelectedTemplate] = useState(null);
  const [refreshKey, setRefreshKey] = useState(0);
  const [activeTemplateType, setActiveTemplateType] = useState('ddq');

  function handleSaved() {
    setView('list');
    setSelectedTemplate(null);
    setRefreshKey(k => k + 1);
  }

  const tabStyle = (active) => ({
    padding: '8px 20px',
    border: 'none',
    background: 'none',
    cursor: 'pointer',
    fontSize: 14,
    fontWeight: active ? 600 : 400,
    color: active ? 'var(--color-accent)' : 'var(--color-text-secondary)',
    borderBottom: active ? '2px solid var(--color-accent)' : '2px solid transparent',
  });

  return (
    <div className="page-container">
      <div className="page-header">
        <div>
          <h1>Questionnaire Templates</h1>
          <p>Configure DDQ and DSQ templates with fixed and configurable sections.</p>
        </div>
      </div>

      {view === 'list' && (
        <>
          <div style={{ display: 'flex', borderBottom: '1px solid var(--color-border)', marginBottom: 20 }}>
            <button style={tabStyle(activeTemplateType === 'ddq')} onClick={() => setActiveTemplateType('ddq')}>
              DDQ Templates
            </button>
            <button style={tabStyle(activeTemplateType === 'dsq')} onClick={() => setActiveTemplateType('dsq')}>
              DSQ Templates
            </button>
          </div>
          <DDQList
            key={`${refreshKey}-${activeTemplateType}`}
            typeFilter={activeTemplateType}
            onAdd={() => { setSelectedTemplate(null); setView('add'); }}
            onEdit={(tmpl) => { setSelectedTemplate(tmpl); setView('edit'); }}
          />
        </>
      )}

      {(view === 'add' || view === 'edit') && (
        <div>
          <div style={{ marginBottom: 20 }}>
            <Button variant="ghost" onClick={() => { setView('list'); setSelectedTemplate(null); }}>
              ← Back to Templates
            </Button>
          </div>
          <h2 style={{ fontSize: 18, fontWeight: 600, marginBottom: 20 }}>
            {view === 'add' ? 'New Template' : `Edit: ${selectedTemplate?.name}`}
          </h2>
          <DDQForm
            template={view === 'edit' ? selectedTemplate : null}
            defaultTemplateType={activeTemplateType}
            onSaved={handleSaved}
            onCancel={() => { setView('list'); setSelectedTemplate(null); }}
          />
        </div>
      )}
    </div>
  );
}
